import React from 'react'

const IconDisplayVerticalSuccess = ({ width = '48', height = '48' }) => (
  <svg
    width={`${width}px`}
    height={`${height}px`}
    viewBox={`0 0 ${width} ${height}`}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        fill="currentColor"
        d="M32,46 L32,48 L16,48 L16,46 L32,46 Z M39,0 L39,44 L9,44 L9,0 L39,0 Z M37,2 L11,2 L11,42 L37,42 L37,2 Z M31.263456,15 L32.6776695,16.4142136 L20.6568542,28.4350288 L15,22.7781746 L16.4142136,21.363961 L20.657,25.606 L31.263456,15 Z"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default IconDisplayVerticalSuccess
